import type { StoreHeaderCarouselSlide } from '@/components/store-header-carousel';

export const CATALOG_HEADER_IMAGE_MAX_COUNT = 3;

/** Desktop banner — e.g. 1200×400 px (width / height = 3). */
export const CATALOG_HEADER_WEB_ASPECT = 3;

/** Mobile banner — e.g. 900×360 px (width / height = 2.5). */
export const CATALOG_HEADER_MOBILE_ASPECT = 2.5;

export type CatalogHeaderImageSlide = {
  webUrl: string;
  mobileUrl: string;
};

function parseHttpUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) return null;
  return trimmed;
}

/** Accepts legacy string URLs or `{ webUrl, mobileUrl }` objects. */
export function normalizeCatalogHeaderImages(value: unknown): CatalogHeaderImageSlide[] | null {
  if (!Array.isArray(value)) return null;
  if (value.length > CATALOG_HEADER_IMAGE_MAX_COUNT) return null;

  const slides: CatalogHeaderImageSlide[] = [];
  for (const item of value) {
    if (typeof item === 'string') {
      const url = parseHttpUrl(item);
      if (!url) return null;
      slides.push({ webUrl: url, mobileUrl: url });
      continue;
    }
    if (!item || typeof item !== 'object') return null;
    const rec = item as Record<string, unknown>;
    const webUrl = parseHttpUrl(rec.webUrl);
    const mobileUrl = parseHttpUrl(rec.mobileUrl);
    if (!webUrl || !mobileUrl) return null;
    slides.push({ webUrl, mobileUrl });
  }
  return slides;
}

export function catalogHeaderImagesToCarouselSlides(
  value: unknown
): StoreHeaderCarouselSlide[] {
  const slides = normalizeCatalogHeaderImages(value) ?? [];
  return slides.map((slide) => ({
    webUrl: slide.webUrl,
    mobileUrl: slide.mobileUrl,
    fit: 'cover' as const,
  }));
}
